import { Injectable } from '@angular/core';
import { CoreApiService } from 'src/app/core/core-api.service';
import { endpoints } from 'src/environments/endpoints';

@Injectable({
  providedIn: 'root'
})
export class SolicitarGarantiaService {

  constructor(private apiService: CoreApiService) { }

  solicitarGarantia(body){
    return this.apiService.post(endpoints.solicitarGarantia, body)
  }

  solicitarGarantiaDPGE(params = {}){
    return this.apiService.get(endpoints.garantiaDPGE, {params})
  }

  solicitarGarantiaEntidadeDPGE(params = {}, idInvestidor: string){
    return this.apiService.get(`${endpoints.garantiaEntidadeDPGE}/${idInvestidor}`, {params})
  }

  realizarSolicitacaoGarantiaDPGE(body,params = {}){
    return this.apiService.post(endpoints.garantiaDPGE,body, {params})
  }

  listarDadosUsuario(){
    return this.apiService.get(`${endpoints.listarUsuarios}`)
  }

  acompanharProcessoSolicitacao(params = {}){
    return this.apiService.get(`${endpoints.acompanharProcesso}`, {params})
  }

  listarDetalheSolicitacao(id){
    return this.apiService.get(`${endpoints.garantiaDPGE}/${id}`, {})
  }

  listarEnderecoUsuario(params = {}){
    return this.apiService.get(`${endpoints.recuperaEnderecoUsuario}`, {params})
  }

  validarCodigoAtivo(params= {}){
    return this.apiService.get(`${endpoints.recuperaCodigoAtivoEntidade}`, {params})
  }

  alterarDadosEntidade(body){
    return this.apiService.put(endpoints.updateEntidade,body ,{})
  }

  alterarDadosInvestidor(body){
    return this.apiService.put(endpoints.updateInvestidor,body ,{})
  }

  alterarDadosInvestidorOrdinaria(body){

    return this.apiService.post(endpoints.updateInvestidorOrdinaria, body, {})
  }
}
